var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 53.811",
    enableBackground: "new 0 0 100 53.811",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.419,44.426l-7.544-4.923L73.64,28.894c3.262-2.823,4.341-7.584,2.306-11.605 c-2.385-4.74-8.192-6.651-12.956-4.236c-1.025,0.518-1.888,1.219-2.63,2.01c-3.867-5.05-9.877-10.635-18.543-13.393 c-16.376-5.213-29.41,3.36-30.968,4.339C5.813,9.17,4.283,15.813,7.439,20.863c0.542,0.856,1.209,1.572,1.922,2.215 c0.087,0.116,0.116,0.254,0.215,0.354l17.292,18.887H5.746C2.573,42.317,0,44.885,0,48.057c0,3.185,2.573,5.754,5.746,5.754h34.182 c2.279,0,4.011-1.529,5.261-3.438c1.823-2.783-0.294-6.831-0.956-7.886L31.395,21.76c1.593-0.052,9.385,2.578,18.7,7.236 C66.639,37.271,92.023,52.69,92.023,52.69c2.494,1.632,5.521,1.434,7.149-1.066C100.805,49.129,99.921,46.053,97.419,44.426z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumble);
export default __webpack_public_path__ + "static/media/humble.92111ddc0926a5dce5e06b02e3994245.svg";
export { ForwardRef as ReactComponent };